var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 nopads"},_vm._l((_vm.uniqueMembers),function(member){return _c('member-item',{key:member.id,attrs:{"member":member}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }